import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import { CustomThemeProvider } from './providers/CustomThemeProvider'
import i18n from '../i18n'

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <CustomThemeProvider>
          <App />
        </CustomThemeProvider>
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
)
